import { gsap, ScrollTrigger } from "./globals.js";
import { isLargeNonTouchDevice } from './globals.js';
if (isLargeNonTouchDevice()) {
  document.addEventListener("DOMContentLoaded", () => {
    ScrollTrigger.addEventListener("refreshInit", () => {
      document.querySelectorAll(".dark-section").forEach((section) => {
        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "+=400",
            scrub: 1,
            onEnter: () => {
              document.body.classList.add("dark-mode");
              document.body.classList.remove("light-mode");
            },
            onEnterBack: () => {
              document.body.classList.add("dark-mode");
              document.body.classList.remove("light-mode");
            },
            onLeave: () => {
              document.body.classList.remove("dark-mode");
            },
            onLeaveBack: () => {
              document.body.classList.remove("dark-mode");
            }
          }
        });

        tl.to("body", { backgroundColor: "#033E44", color: "#FFF5ED" });

        if (section.classList.contains("pinned-slider")) {
          tl.to(".hp-about__gradient svg", { opacity: 1 }, "<");
        }
      });

      document.querySelectorAll(".light-section").forEach((section) => {
        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "+=400",
            scrub: 1,
            onEnter: () => {
              document.body.classList.add("light-mode");
              document.body.classList.remove("dark-mode");
            },
            onEnterBack: () => {
              document.body.classList.add("light-mode");
              document.body.classList.remove("dark-mode");
            },
            onLeave: () => {
              document.body.classList.remove("light-mode");
            },
            onLeaveBack: () => {
              document.body.classList.remove("light-mode");
            }
          }
        });

        tl.to("body", { backgroundColor: "#FFF5ED", color: "#033E44" });

        if (section.classList.contains("pinned-slider")) {
          tl.to(".hp-about__gradient svg", { opacity: 0 }, "<");
        }
      });
    });
  });
}
